import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'
import moment from 'moment'

declare type Values = {
  [key: string]: string
}

class UnassignedShiftForm extends Form {
  constructor(values: object | Values = {}) {
    super(values, {
      id: 'string',
      title: 'string',
      start_at: 'string',
      end_at: 'string',
      extra_hours: 'boolean',
      color: 'string',
      overnight_shift: 'boolean',
      notes: 'string',
      work_area_id: 'string',
      location_id: 'string',
      all_company: 'boolean',
      teams_ids_visibilities: 'any',
      locations_ids_visibilities: 'any',
      counter: 'number',
      start_date: 'string',
      end_date: 'string',
      is_selected: 'boolean',
      staff_requirements: 'any',
      job_catalog_roles_ids: 'any',
      job_catalog_tree_role_uuids: 'any',
    })
    makeObservable(this, {
      startAt: computed,
      endAt: computed,
      isSelected: computed,
      isOvernight: computed,
      isVisibilitySelected: computed,
      isValid: computed,
    })
  }

  get startAt() {
    return moment(this.get('start_time').value, 'HH:mm')
  }

  get endAt() {
    return moment(this.get('end_time').value, 'HH:mm')
  }

  get isSelected(): boolean {
    return this.get('is_selected').value
  }

  get isOvernight(): boolean {
    const startTime = this.get('start_at').value
    const endTime = this.get('end_at').value

    return endTime && startTime && endTime < startTime
  }

  get isVisibilitySelected(): boolean {
    const allCompany = this.get('all_company').value
    const teamsIdsVisibilities = this.get('teams_ids_visibilities').value
    const locationsIdsVisibilities = this.get('locations_ids_visibilities').value

    return !!allCompany || !!teamsIdsVisibilities || !!locationsIdsVisibilities
  }

  get isValid(): boolean {
    const isValidStartAt = this.get('start_at').value.length > 0
    const isValidEndAt = this.get('end_at').value.length > 0

    return this.isDirty && isValidStartAt && isValidEndAt
  }
}

export default UnassignedShiftForm
